module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('SitePage_Pricing', {
		configure: function (options) {
			
			this.callParent('configure', arguments);
		},

		activate: function () {
			var layout = this.getParent().fragment;
			var menuLinks = fox.dom.select('#promo-top-menu .lnk', layout);

			if (menuLinks.length) {
				fox.each(menuLinks, function (link) {
					var link = fox.dom.wrap(link);
					var goTo = link.attr('goTo')
					link.removeClass('active');

					if (goTo && goTo == fox.Navigator.get(0)) {
						link.addClass('active');
					}
				});
			}
			this.callParent('activate', arguments);
		}

	}, 'Site_Page');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/widget/sitepage/pricing.js
// module id = 477
// module chunks = 2